import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  title: 'AEDBIS',
  api: 'https://aedbis-dev-api.amazone.de/api/v1/',
  notificationsUrl: 'https://aedbis-dev-api.amazone.de/',
  supportMailAddress: 'team.aedbis@amazone.de',
  coreApiDocUrl: 'https://aedbis-dev-core-api.amazone.de/api/docs',
  debounceTimespan: 750,
  aiInstrumentationKey: '0928aea5-cd80-45e1-856c-81fd6dfa2c03',
  msalConfig: {
    auth: {
      clientId: '0aa27a6c-a442-401d-a539-ab2aa9461813',
      authority: 'https://login.microsoftonline.com/813890b8-741a-44f2-a5e3-5c65fc5e205b',
    },
  },
  apiConfig: {
    // scopes: ['user.read'], // Needed for querying ms graph
    scopes: ['api://a097f342-cbfb-4808-b481-c23916b78b68/.default'], // needed to access our own api

    // uri: 'https://graph.microsoft.com/v1.0/me', // Needed for querying ms graph
    uri: 'https://aedbis-dev-api.amazone.de/api', // needed to access our own api
  },
  versionInfo: 'dev_4528492de5cba21469558712a3d78ab29577ae8e.1.33.0-alpha.499',
};
